export const templateTypeList = [
  'basic',
  'custom',
  'index',
  'index_table',
  'create',
  'edit',
  'edit_tabbed',
  'dashboard',
  'under_development',
  'tabbed',
] as const;

export type TemplateType = typeof templateTypeList[number];

